import { DEBUG_PANEL_DEFAULT_HEIGHT_PX } from '@/constants';
import type { BrowserInfo, StorageEstimate } from '@/types/Diagnostics';
import type { LogEntry } from '@/types/LogEntry';
import { LogLevel } from '@/types/Logger';
import type { P2PDiagnostics } from '@/types/P2PDiagnostics';

export interface DebugState {
  isOpen: boolean;
  heightPx: number;
  storageEstimate: StorageEstimate | null;
  browserInfo: BrowserInfo | null;
  lastRefreshedAt: number | null;
  logEntries: LogEntry[];
  logNamespaces: string[];
  logLevel: LogLevel;
  p2pDiagnostics: P2PDiagnostics | null;
}

export const initialDebugState: DebugState = {
  isOpen: false,
  heightPx: DEBUG_PANEL_DEFAULT_HEIGHT_PX,
  storageEstimate: null,
  browserInfo: null,
  lastRefreshedAt: null,
  logEntries: [],
  logNamespaces: [],
  logLevel: LogLevel.INFO,
  p2pDiagnostics: null,
};
